<div class="slideshow" [class.hidden]="!opened">
    <button mat-icon-button matTooltip="Schließen" (click)="close()" class="close-icon">
    <mat-icon>close</mat-icon>
  </button>
    <img #img *ngIf="images" [src]="images[index]">
</div>